import React, { useEffect, useState, useRef } from 'react';
import './Navbar.css';
import flagUK from '../assets/flag-uk.png';
import flagPT from '../assets/flag-pt.png';
import logo from '../assets/Branco_logo1.png';
import { FiX } from 'react-icons/fi';

const Navbar = ({ language, changeLanguage, setActiveSection, activeSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const drawerRef = useRef(null);

  const toggleLanguage = () => {
    changeLanguage(language === 'en' ? 'pt' : 'en');
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => setMenuOpen(false);

  const t = {
    en: {
      home: "Home",
      about: "About Us",
      services: "Services",
      contact: "Contact Us",
    },
    pt: {
      home: "Início",
      about: "Sobre Nós",
      services: "Serviços",
      contact: "Contacte-nos",
    },
  }[language];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        closeMenu();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="navbar">
      <div className="navbar-container">
        <div className="logo-section">
          <button className="logo-btn" onClick={() => { setActiveSection('home'); closeMenu(); }}>
            <img src={logo} alt="Site Logo" className="nav-logo" />
          </button>
        </div>

        <div className="right-section">
          <button
            className="lang-btn"
            onClick={toggleLanguage}
            data-tooltip={language === 'en' ? 'Mudar para Português' : 'Switch to English'}
          >
            <img src={language === 'en' ? flagPT : flagUK} alt="Language" />
          </button>

          <div className="hamburger" onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>
      </div>

      {menuOpen && <div className="drawer-overlay" onClick={closeMenu}></div>}

      <div ref={drawerRef} className={`nav-drawer ${menuOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <button className="close-btn" onClick={closeMenu}>
            <FiX size={28} color="white" />
          </button>
        </div>

        <button className={`nav-link ${activeSection === 'home' ? 'active' : ''}`} onClick={() => { setActiveSection('home'); closeMenu(); }}>{t.home}</button>
        <button className={`nav-link ${activeSection === 'about' ? 'active' : ''}`} onClick={() => { setActiveSection('about'); closeMenu(); }}>{t.about}</button>
        <button className={`nav-link ${activeSection === 'services' ? 'active' : ''}`} onClick={() => { setActiveSection('services'); closeMenu(); }}>{t.services}</button>
        <button className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`} onClick={() => { setActiveSection('contact'); closeMenu(); }}>{t.contact}</button>
      </div>
    </div>
  );
};

export default Navbar;
